import React, { useEffect, useState } from "react";
import calendlyAssessmentStyle from "./calendlyAssessmentStyle";
import { Box, Grid, IconButton, Rating } from "@mui/material";
import { translate } from "../../services/Translations/translatorService";
import { nl2br } from "../../services/formServiceFunctions";
import ApiClient from "../../services/ApiClient";
import { Activity } from "../../types/Activity";
import { CalendlyAssessment } from "../../types/Calendly/CalendlyAssessment";
import { UnfoldLess, UnfoldMore } from "@mui/icons-material";
import { stripHtml } from "string-strip-html";

export default function CalendlyAssessmentActivity({ activity }: { activity: Activity }) {
  const [calendlyEvent, setCalendlyEvent] = useState<any>(null);
  const [isCallSummaryExpanded, setIsCallSummaryExpanded] = useState<boolean>(false);

  useEffect(() => {
    if (!!activity.calendlyEvent && !calendlyEvent) {
      ApiClient.get(activity.calendlyEvent).then((response: any) => setCalendlyEvent(response));
    }
  }, [activity, calendlyEvent]);

  if (
    !calendlyEvent ||
    !activity.done ||
    !["calendly_event", "lawyer_counseling_call"].includes(activity.type) ||
    !calendlyEvent ||
    !calendlyEvent.assessment ||
    calendlyEvent.assessment.processed === null
  ) {
    return null;
  }

  const { assessment }: { assessment: CalendlyAssessment } = calendlyEvent;

  const boolToText = (value: boolean | null) => {
    if (value === null) {
      return "-";
    }
    return value ? "Ja" : "Nein";
  };

  return (
    <Box sx={calendlyAssessmentStyle.assessmentContainer}>
      <Grid container spacing={1}>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          Gespräch stattgefunden: {boolToText(assessment.processed)}
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          {assessment.notProcessedReason && (
            <>
              Warum nicht:{" "}
              {translate("assessment.short.notProcessedReason.values." + assessment.notProcessedReason, "-")}
            </>
          )}
        </Grid>
        {activity.type === "calendly_event" && (
          <>
            <Grid
              size={{
                xs: 12,
                md: 6
              }}>
              Weitere Mandatstätigkeiten notwendig: {boolToText(assessment.followUp)}
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6
              }}>
              {assessment.followUpAction && (
                <>
                  Weitere Tätigkeit:{" "}
                  {translate("assessment.short.followUpAction.values." + assessment.followUpAction, "-")}
                </>
              )}
            </Grid>
            <Grid size={12}>
              Übernahme des Mandats: {boolToText(assessment.acceptsMandateTransferal)}
            </Grid>
            <Grid size={12}>
              Zufriedenheit Mandantschaft:
              <Rating size={"small"} value={assessment.customerSatisfaction} readOnly={true} />
            </Grid>
          </>
        )}
        {assessment.note && (
          <Grid size={12}>
            Hinweise:
            <Box
              sx={calendlyAssessmentStyle.noteContainer}
              dangerouslySetInnerHTML={{ __html: nl2br(assessment.note) }}
            />
          </Grid>
        )}

        {assessment.callSummary && stripHtml(assessment.callSummary).result && assessment.processed && (
          <Grid size={12}>
            Zusammenfassung:
            <Grid
              container
              spacing={1}
              sx={[{
                alignItems: "flex-start"
              }, calendlyAssessmentStyle.noteContainer]}>
              <Grid
                size={{
                  xs: 12,
                  md: 11
                }}>
                <Box
                  sx={{
                    pt: 1,
                    ...(isCallSummaryExpanded ? {} : calendlyAssessmentStyle.collapsedNote),
                  }}
                  dangerouslySetInnerHTML={{ __html: nl2br(assessment.callSummary) }}
                />
              </Grid>
              <Grid
                sx={{ display: "flex", justifyContent: { xs: "flex-start", md: "flex-end" } }}
                size={{
                  xs: 12,
                  md: 1
                }}>
                <IconButton
                  onClick={() => setIsCallSummaryExpanded(!isCallSummaryExpanded)}
                  aria-label={isCallSummaryExpanded ? "Weniger anzeigen" : "Mehr anzeigen"}
                  size="small"
                >
                  {isCallSummaryExpanded ? <UnfoldLess /> : <UnfoldMore />}
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
